export default "__VITE_ASSET__BLuy9iHSHEMW1J$kGVoNHg__"